type Props = {
  title: string
  subtitle?: string | null
}

export function AnswerChoiceListItem({ title, subtitle }: Props) {
  return (
    <div className="flex flex-col gap-y-1.5">
      <p className="text-base font-medium leading-tight text-gray-800">
        {title}
      </p>
      {subtitle && (
        <p className="text-sm leading-tight text-gray-600">{subtitle}</p>
      )}
    </div>
  )
}
